export default "__VITE_ASSET__BJjGqLA___"